export default "__VITE_ASSET__DbLE02oJ__"